<template>
  <div class="com-lol-ban-pick">
    <div class="team-wrapper">
      <div class="team-box">
        <div class="team-logo"><img v-hb-img.src="dataInfo.blue.img" /></div>
        <p>{{ dataInfo.blue.name }}</p>
      </div>
      <div class="static-color-desc-banpick"><p>vs</p></div>
      <div class="team-box reverse">
        <p>{{ dataInfo.red.name }}</p>
        <div class="team-logo"><img v-hb-img.src="dataInfo.red.img" /></div>
      </div>
    </div>
    <div class="order-list ban-list">
      <div class="team-order-list">
        <div
          class="order-item"
          v-for="(item, index) in dataInfo.blue.bans"
          :key="index"
        >
          <img v-hb-img.src="item.img" />
        </div>
      </div>
      <p class="order-list-desc">Ban</p>
      <div class="team-order-list reverse">
        <div
          class="order-item"
          v-for="(item, index) in dataInfo.red.bans"
          :key="index"
        >
          <img v-hb-img.src="item.img" />
        </div>
      </div>
    </div>
    <div class="order-list">
      <div class="team-order-list reverse">
        <div
          class="order-item"
          v-for="(item, index) in dataInfo.blue.picks"
          :key="index"
        >
          <img v-hb-img.src="item.img" />
        </div>
      </div>
      <p class="order-list-desc">Pick</p>
      <div class="team-order-list reverse">
        <div
          class="order-item"
          v-for="(item, index) in dataInfo.red.picks"
          :key="index"
        >
          <img v-hb-img.src="item.img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="less">
.com-lol-ban-pick {
  width: 100%;
  height: 119px;
  padding: 10px;
  border-radius: 8px;
  .team-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &::after {
      content: '';
      position: absolute;
      top: calc(100% + 6px);
      left: 0;
      width: 100%;
      height: 1px;
      transform: scaleY(0.5);
      background: rgba(243, 244, 245, 1);
    }
    .team-box {
      display: flex;
      align-items: center;
      width: 150px;
      p {
        margin: 0;
      }
      img {
        margin: 0;
      }
      &.reverse {
        justify-content: flex-end;
        p {
          margin-right: 6px;
          margin-left: 0px;
        }
      }
      .team-logo {
        height: 24px;
        width: 24px;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
      p {
        margin-left: 6px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(20, 25, 30, 1);
      }
    }
    .static-color-desc-banpick {
      font-size: 11px;
      color: rgba(206, 157, 30, 1);
    }
  }
  .order-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 13px;
    &.ban-list {
      .team-order-list {
        opacity: 0.6;
      }
    }
    & + .order-list {
      margin-top: 6px;
    }
    .team-order-list {
      display: flex;
      align-items: center;
      .order-item {
        width: 28px;
        height: 28px;
        & + .order-item {
          margin-left: 2px;
        }
        img {
          width: 100%;
          height: 100%;
          margin: 0;
          border-radius: 3px;
        }
      }
    }
    .order-list-desc {
      margin: 0;
      font-size: 10px;
      color: rgba(140, 145, 150, 1);
    }
  }
  .report-info-bot {
    background: rgba(243, 244, 245, 1);
  }
}
</style>
